import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Mutations {
  createGroup(): DocumentNode {
    return gql`
      mutation createGroup($input: GroupInput!) {
        createGroup(input: $input) {
          id
          name
          description
          users {
            id
            name
            email
            type
          }
        }
      }
    `;
  }

  updateGroup(): DocumentNode {
    return gql`
      mutation updateGroup($id: ID!, $input: GroupInput!) {
        updateGroup(id: $id, input: $input) {
          id
          name
          description
          users {
            id
            name
            email
            type
          }
        }
      }
    `;
  }
}
